import { am5, am5xy } from '@local/finsera-core/src/libs';
import * as types from '@local/finsera-core/src/types';

export const createSeries = ({
  root,
  chart,
  data,
  categoryAxis,
  valueAxis1,
  valueAxis2,
  xAxisField,
  innerBar,
  innerBarTitle,
  outerBar,
  outerBarTitle,
  line,
  lineTitle,
  seriesColorByName,
}: {
  root: am5.Root;
  chart: am5xy.XYChart;
  data: types.widgets.TableData;
  categoryAxis: am5xy.CategoryAxis<am5xy.AxisRenderer>;
  valueAxis1: am5xy.ValueAxis<am5xy.AxisRenderer>;
  valueAxis2: am5xy.ValueAxis<am5xy.AxisRenderer>;
  xAxisField: string;
  innerBar: string;
  innerBarTitle: string;
  outerBar: string;
  outerBarTitle: string;
  line: string;
  lineTitle: string;
  valueAxis: am5xy.ValueAxis<am5xy.AxisRenderer>;
  seriesColorByName: Record<string, string>;
}) => {
  const innerBarColor = seriesColorByName[innerBarTitle];
  const outerBarColor = seriesColorByName[outerBarTitle];
  const lineColor = seriesColorByName[lineTitle];
  const series1 = chart.series.push(
    am5xy.ColumnSeries.new(root, {
      name: innerBarTitle,
      xAxis: categoryAxis,
      yAxis: valueAxis1,
      valueYField: innerBar,
      categoryXField: xAxisField,
      clustered: false,
      fill: am5.Color.lighten(am5.color(innerBarColor), 0.5),
      tooltip: am5.Tooltip.new(root, {
        labelText: '{name}\n[bold]{valueY}[/]',
      }),
    })
  );

  series1.columns.template.setAll({
    width: am5.percent(40),
  });

  const series2 = chart.series.push(
    am5xy.ColumnSeries.new(root, {
      name: outerBarTitle,
      xAxis: categoryAxis,
      yAxis: valueAxis1,
      valueYField: outerBar,
      categoryXField: xAxisField,
      clustered: false,
      fill: am5.color(outerBarColor),
      tooltip: am5.Tooltip.new(root, {
        labelText: '{name}\n[bold]{valueY}[/]',
      }),
    })
  );

  series2.toBack();

  const series3 = chart.series.push(
    am5xy.SmoothedXLineSeries.new(root, {
      name: lineTitle,
      xAxis: categoryAxis,
      yAxis: valueAxis2,
      valueYField: line,
      categoryXField: xAxisField,
      tension: 0.5,
      fill: am5.color(lineColor),
      stroke: am5.color(lineColor),
      tooltip: am5.Tooltip.new(root, {
        labelText: '{name}\n[bold]{valueY}[/]',
      }),
    })
  );

  series3.strokes.template.set('strokeWidth', 2);

  series3.bullets.push(() => {
    return am5.Bullet.new(root, {
      sprite: am5.Circle.new(root, {
        radius: 3,
        fill: am5.color('#fff'),
        stroke: am5.color(lineColor),
        strokeWidth: 2,
      }),
    });
  });

  series1.data.setAll(data);
  series2.data.setAll(data);
  series3.data.setAll(data);

  return [series1, series2, series3];
};
